__turbopack_context__.v({
  "className": "poppins_4a844ba7-module__eKceeW__className",
  "variable": "poppins_4a844ba7-module__eKceeW__variable",
});
